import type { Category } from "@/types";

export const categories: Category[] = [
  {
    id: "movie",
    name: "电影",
    nameEn: "Movies",
    description:
      "汇聚院线佳片与经典电影，从悬疑犯罪到温情文艺，为你梳理每一部作品的核心剧情脉络与角色弧光，让两小时的银幕时光不留疑问。",
    icon: "ri-film-line",
  },
  {
    id: "tv",
    name: "电视剧",
    nameEn: "TV Series",
    description:
      "长篇剧集往往线索繁复、人物众多。这里按题材分类整理电视剧的剧情主线、关键转折与人物关系，帮你跟上每一次更新节奏。",
    icon: "ri-tv-2-line",
  },
  {
    id: "web",
    name: "网络剧",
    nameEn: "Web Series",
    description:
      "节奏明快、题材新锐的网络剧正在改变观剧习惯。我们聚焦短剧集的强情节与高口碑作品，带你快速判断哪一部值得追。",
    icon: "ri-smartphone-line",
  },
];